import React from 'react';

function Tab (props) {
        return (
            <div>
                <p>{props.text}</p>
            </div>
        )
    };

export default Tab;